import SingleOfflineExhibitor from "./SingleOfflineExhibitor";

export default SingleOfflineExhibitor;
